import PropTypes from "prop-types";
import { cloneElement } from "react";
import Immutable from "immutable";
import cookie from "react-cookie";
import Page from "components/page";
import shallowequal from "shallowequal";

export default function () {
    return function (Component) {
        class PageMixin extends Component {
            componentDidMount() {
                const { router, me } = this.context;
                if (this.props.location.query && this.props.location.query.campaignId && me._id) {
                    if (me.account_type === "buyer") {
                        cookie.save(
                            `user_${me._id}_campaign_for_${this.props.params.brand}`,
                            this.props.location.query.campaignId,
                            {
                                path: "/",
                                domain: window.location.host.replace(/^app/, ""),
                            }
                        );
                    }

                    const query = Object.assign({}, this.props.location.query);
                    delete query.campaignId;
                    router.replace({
                        pathname: this.props.location.pathname,
                        query,
                    });
                }

                if (this.props.filters) {
                    router.replace({
                        pathname: this.props.location.pathname,
                        query: { ...this.props.location.query, ...(this.props.filters.toJS?.() ?? this.props.filters) },
                    });
                }

                if (super.componentDidMount) {
                    super.componentDidMount();
                }
            }

            UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
                const { router } = nextContext;
                // save history to address bar
                if (PageMixin._pageComponents.length > 0) {
                    if (
                        nextState.searchTerm !== this.state.searchTerm ||
                        nextState.bulkSearch !== this.state.bulkSearch ||
                        nextState.bulkSearchType !== this.state.bulkSearchType ||
                        (PageMixin._pageComponents.includes("filters") && nextState.filters !== this.state.filters) ||
                        (PageMixin._pageComponents.includes("sort") && nextState.sort !== this.state.sort) ||
                        (PageMixin._pageComponents.includes("sort") && nextState.sortOrder !== this.state.sortOrder)
                    ) {
                        let query = nextState.filters || Immutable.Map();

                        if (nextState.searchTerm) {
                            query = query.set("__search", nextState.searchTerm);
                        }

                        if (nextState.bulkSearch) {
                            query = query.set("__bulk_search", nextState.bulkSearch);
                            if (nextState.bulkSearchType) {
                                query = query.set("__bulk_search_type", nextState.bulkSearchType);
                            }
                        }

                        if (PageMixin._pageComponents.includes("sort")) {
                            if (nextState.sort !== this.defaultSort) {
                                query = query.set("__sort", nextState.sort);
                            }

                            if (nextState.sortOrder !== this.defaultSortOrder) {
                                query = query.set("__sort_order", nextState.sortOrder);
                            }
                        }

                        if (this.enhanceHistoryChange) {
                            query = this.enhanceHistoryChange(query, nextProps, nextState, nextContext);
                        }
                        router.replace({
                            pathname: nextProps.location.pathname,
                            query: query.toJS(),
                        });
                    }
                }

                if (super.UNSAFE_componentWillUpdate) {
                    super.UNSAFE_componentWillUpdate(nextProps, nextState, nextContext);
                }
            }

            shouldComponentUpdate(nextProps, nextState, nextContext) {
                if (
                    nextContext.viewAs !== this.context.viewAs ||
                    nextProps.location.pathname !== this.props.location.pathname
                ) {
                    return true;
                }

                if (super.shouldComponentUpdate) {
                    return super.shouldComponentUpdate(nextProps, nextState, nextContext);
                } else {
                    return (
                        !shallowequal(this.props, nextProps) ||
                        !shallowequal(this.state, nextState) ||
                        !shallowequal(this.context, nextContext)
                    );
                }
            }

            render() {
                const content = super.render();
                if (content.type === Page) {
                    return cloneElement(content, {
                        searchScope: this.state.searchScope || "all",
                        defaultSearchTerm: this.state.defaultSearchTerm || "",
                    });
                }
                return content;
            }
        }

        PageMixin._pageComponents = PageMixin._pageComponents || [];

        PageMixin.contextTypes = {
            router: PropTypes.object.isRequired,
            viewAs: PropTypes.object,
            me: PropTypes.object.isRequired,
            ...PageMixin.contextTypes,
        };

        PageMixin.displayName = Component.displayName || Component.name || "Component";

        return PageMixin;
    };
}
